export default {
  name: 'subscription_new',
  url: '/:orgId/subscription_overview',
  label: 'Subscription',
  componentName: 'cf-subscription-overview'
};



// WEBPACK FOOTER //
// ./src/javascripts/app/OrganizationSettings/Subscription/SubscriptionState.es6.js